import { ProfileActionButtons } from './ProfileActionButtons';
import { ProfilePhotos } from './ProfilePhotos';
import { ProfileInformation } from './ProfileInformation';
import { GiftListProfile } from '../gifts/GiftListProfile';
import { calculateAge } from '../../utils/calculateAge';

export function ProfileExampleByData({
  children,
  userData,
  actionButtons,
  showActionButtons = true,
  showGifts = true,
  photosVisibleCount = Infinity,
  className = ''
}) {
  if (!userData) {
    return null;
  }

  const age = userData.birthDay ? calculateAge(userData.birthDay) : null;

  return (
    <>
      {showActionButtons && userData._id && <ProfileActionButtons userId={userData._id} />}
      <div className={`relative w-full rounded-[16px] overflow-hidden p-4 ${className}`}>
        <div className="relative">
          <ProfilePhotos photos={userData.photos} heightClassName="h-[70vh]" visibleCount={photosVisibleCount}>
            {actionButtons && actionButtons}
          </ProfilePhotos>
        </div>
        <div className="absolute left-0 right-0 bottom-0 px-6 pb-8 z-[6] pointer-events-none">
          <h1 className="font-raleway font-bold text-white text-[clamp(22px,6vw,28px)] leading-tight drop-shadow-[0_2px_6px_rgba(0,0,0,0.7)] truncate">
            {userData.name || 'Имя не указано'}
            {age != null && `, ${age} лет`}
          </h1>
          <h2 className="font-raleway font-light text-white text-[clamp(15px,4vw,18px)] mt-1 drop-shadow-[0_2px_6px_rgba(0,0,0,0.7)] truncate">
            {userData.city || 'Город не указан'}, {userData.country || 'Страна не указана'}
          </h2>
        </div>
        <div className="p-6 bg-[#010D0D] rounded-b-[16px]">
          <ProfileInformation
            name={userData.name}
            birthDay={userData.birthDay}
            city={userData.city}
            country={userData.country}
            purpose={userData.purpose}
            audioMessage={userData.audioMessage}
            interests={userData.interests}
            about={userData.about}
            showHeader={false}
          />
          {showGifts && userData._id && <GiftListProfile userId={userData._id} />}
        </div>
      </div>
      {children}
    </>
  );
}
